"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = reducer;
exports.setSelected = exports.setFields = exports.setField = exports.setData = exports.setCheckedItems = exports.setApi = exports.reset = exports.init = exports.getGridData = exports.getApiKey = void 0;
var _excluded = ["field", "order"],
    _excluded2 = ["type", "gridKey", "field"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var actions = {
  INIT_GRID_API: 'INIT_GRID_API',
  UPDATE_GRID_API: 'UPDATE_GRID_API',
  UPDATE_GRID_FIELDS: 'UPDATE_GRID_FIELDS',
  UPDATE_GRID_FIELD: 'UPDATE_GRID_FIELD',
  UPDATE_GRID_CHECKED_ITEMS: 'UPDATE_GRID_CHECKED_ITEMS',
  UPDATE_GRID_DATA: 'UPDATE_GRID_DATA',
  RESET_GRID: 'RESET_GRID',
  SET_GRID_SELECTED: 'SET_GRID_SELECTED'
};
var initData = {
  api: {
    key: null,
    page: 1,
    limit: 30,
    start: 0,
    query: '',
    sort_field: undefined,
    sort_order: undefined,
    checkedItems: [] // filter: {},
    // destroyOnUnmount: true

  },
  params: {
    fields: null,
    total: null,
    options: {},
    t: function t() {},
    filter: {
      onChange: function onChange() {}
    },
    sort: {
      onChange: function onChange() {}
    },
    pagination: {},
    onChangeFields: function onChangeFields() {},
    title: null
  },
  urlVars: {},
  update: false,
  version: null,
  result: null
};
/* selectors */

var getGridData = function getGridData(grid, gridKey) {
  var _ref = grid[gridKey] || initData,
      api = _ref.api,
      params = _ref.params,
      result = _ref.result,
      update = _ref.update,
      version = _ref.version;

  return {
    api: api,
    params: params,
    result: result,
    update: update,
    version: version
  };
};
/* updaters */


exports.getGridData = getGridData;

var updateApi = function updateApi(prevApi, nextApi) {
  var field = nextApi.field,
      order = nextApi.order,
      rest = _objectWithoutProperties(nextApi, _excluded);

  var api = _objectSpread(_objectSpread({}, prevApi), rest);

  if (nextApi.query) {
    api.page = prevApi.query === nextApi.query ? api.page : 1;
  }

  if (field) {
    api.sort_field = !!field && !!order ? field : undefined;
    api.sort_order = !!field && !!order ? order : undefined;
    /** for CRM API **/

    api.sort = [{
      property: field,
      direction: order.toUpperCase()
    }];
    /** end **/
  }

  api.start = ((api.page || prevApi.page) - 1) * api.limit;
  return api;
};

var updateParams = function updateParams(prevParams, nextParams, api) {
  var params = _objectSpread(_objectSpread({}, prevParams), nextParams);

  var limit = api.limit,
      page = api.page;
  params.pagination.data = {
    limit: limit,
    page: page,
    total: nextParams.total
  };
  params.filter = _objectSpread(_objectSpread({}, params.filter), {}, {
    defaultValue: api.query
  });
  params.sort = _objectSpread(_objectSpread({}, params.sort), {}, {
    field: api.sort_field,
    order: api.sort_order
  });
  params.options.selected = params.options.mountSelect ? params.options.selected : null;
  return params;
};
/* reducer */


function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.type in actions) {
    var type = action.type,
        gridKey = action.gridKey,
        field = action.field,
        rest = _objectWithoutProperties(action, _excluded2);

    var api = rest.api,
        params = rest.params,
        result = rest.result,
        selected = rest.selected;
    var prevGrid = state[gridKey] || initData;

    switch (type) {
      case actions.INIT_GRID_API:
        {
          var grid = {
            api: updateApi(prevGrid.api, api)
          };
          grid.params = _objectSpread(_objectSpread({}, prevGrid.params), params);
          grid.params.pagination.data = prevGrid.params.pagination.data || params.pagination.data;
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({
            gridKey: gridKey
          }, gridKey, _objectSpread(_objectSpread(_objectSpread({}, prevGrid), rest), grid)));
        }

      case actions.UPDATE_GRID_API:
        {
          var _grid = {
            api: updateApi(prevGrid.api, api)
          };
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, gridKey, _objectSpread(_objectSpread(_objectSpread({}, prevGrid), rest), _grid)));
        }

      case actions.UPDATE_GRID_FIELDS:
        {
          var _grid2 = {
            params: _objectSpread(_objectSpread({}, prevGrid.params), params)
          };
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, gridKey, _objectSpread(_objectSpread(_objectSpread({}, prevGrid), rest), _grid2)));
        }

      case actions.UPDATE_GRID_FIELD:
        {
          var _grid3 = _objectSpread(_objectSpread({}, prevGrid), {}, {
            params: _objectSpread(_objectSpread({}, prevGrid.params), {}, {
              fields: _objectSpread(_objectSpread({}, prevGrid.params.fields), field)
            })
          });

          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, gridKey, _grid3));
        }

      case actions.UPDATE_GRID_CHECKED_ITEMS:
        {
          var _grid4 = {
            params: _objectSpread(_objectSpread({}, prevGrid.params), {}, {
              groups: _objectSpread(_objectSpread({}, prevGrid.params.groups), {}, {
                checkedItems: _toConsumableArray(params.checkedItems)
              })
            })
          };
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, gridKey, _objectSpread(_objectSpread(_objectSpread({}, prevGrid), rest), _grid4)));
        }

      case actions.UPDATE_GRID_DATA:
        {
          var _grid5 = {
            result: result,
            params: updateParams(prevGrid.params, params, prevGrid.api)
          };
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, gridKey, _objectSpread(_objectSpread(_objectSpread({}, prevGrid), rest), _grid5)));
        }

      case actions.RESET_GRID:
        {
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({
            gridKey: null
          }, gridKey, null));
        }

      case actions.SET_GRID_SELECTED:
        {
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, gridKey, _objectSpread(_objectSpread({}, prevGrid), {}, {
            params: _objectSpread(_objectSpread({}, prevGrid.params), {}, {
              options: _objectSpread(_objectSpread({}, prevGrid.params.options), {}, {
                selected: selected
              })
            })
          })));
        }

      default:
        return state;
    }
  }

  return state;
}
/* action creators */


var init = function init(_ref2) {
  var api = _ref2.api,
      params = _ref2.params,
      gridKey = _ref2.gridKey,
      update = _ref2.update,
      version = _ref2.version;
  return {
    type: actions.INIT_GRID_API,
    gridKey: gridKey,
    api: api,
    params: params,
    update: update,
    version: version
  };
}; // eslint-disable-next-line max-len


exports.init = init;

var setApi = function setApi(data, gridKey) {
  return {
    type: actions.UPDATE_GRID_API,
    gridKey: gridKey,
    api: data,
    update: true
  };
};

exports.setApi = setApi;

var setFields = function setFields(fields, gridKey) {
  return {
    type: actions.UPDATE_GRID_FIELDS,
    gridKey: gridKey,
    params: {
      fields: fields
    },
    update: false
  };
};

exports.setFields = setFields;

var setField = function setField(field, gridKey) {
  return {
    type: actions.UPDATE_GRID_FIELD,
    gridKey: gridKey,
    field: field,
    update: false
  };
};

exports.setField = setField;

var setCheckedItems = function setCheckedItems(checkedItems, gridKey) {
  return {
    type: actions.UPDATE_GRID_CHECKED_ITEMS,
    gridKey: gridKey,
    params: {
      checkedItems: checkedItems
    },
    update: false
  };
};

exports.setCheckedItems = setCheckedItems;

var setData = function setData(result, gridKey) {
  return {
    type: actions.UPDATE_GRID_DATA,
    gridKey: gridKey,
    result: result,
    params: {
      total: result.total || result.total_count
    },
    update: false
  };
};

exports.setData = setData;

var setSelected = function setSelected(selected, gridKey) {
  return {
    type: actions.SET_GRID_SELECTED,
    gridKey: gridKey,
    selected: selected
  };
};

exports.setSelected = setSelected;

var reset = function reset(gridKey) {
  return {
    type: actions.RESET_GRID,
    gridKey: gridKey
  };
};

exports.reset = reset;

var getApiKey = function getApiKey(tuner, params) {
  var _tuner = _objectSpread({}, tuner(params)),
      _tuner$urlVars = _tuner.urlVars,
      urlVars = _tuner$urlVars === void 0 ? {} : _tuner$urlVars,
      gridKey = _tuner.gridKey,
      initApi = _tuner.api;

  var parts = '';

  if (gridKey) {
    parts = "_".concat(gridKey);
  } else {
    Object.keys(urlVars).forEach(function (k) {
      parts += "_".concat(urlVars[k]);
    });
  }

  return initApi.key + parts;
};

exports.getApiKey = getApiKey;